import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { formatRuDateTimeString } from '../../../../../../helpers/date-time';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useCheckInCheckOutStore } from '../../../../../../store/use-check-in-check-out-store';
import s from './check-in-check-out-list-modal.module.css';

export const CheckInCheckOutListModal = (props: ModalProps) => {
  const { t } = useLang();
  const { checkins } = useCheckInCheckOutStore();

  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const id = params.checkInId;

  const nestedCheckins = checkins?.find((item) => String(item.id) === id)?.checkins || [];

  return (
    <Modal className={s.feature} title={t('Просмотр сессий')} onClose={props.onClose}>
      {nestedCheckins.map((item) => (
        <li key={item.id} className={s.card}>
          <div className={s.pair}>
            {t('Приход')}
            <span>{item.start_time ? formatRuDateTimeString(item.start_time) : '-'}</span>
          </div>
          <div className={s.pair}>
            {t('Уход')} <span>{item.end_time ? formatRuDateTimeString(item.end_time) : '-'}</span>
          </div>
        </li>
      ))}
    </Modal>
  );
};
